import React from "react";
import { Users, ChevronRight } from "lucide-react";

const AttendanceDashboardList = ({ 
    employees, 
    activeRoster, 
    rosters 
}) => {
    const selectedRosterName = rosters.find(r => r.roster_id === activeRoster)?.roster_name || 'selected';

    return (
        <div className="attendance-list-container">
            {/* Employee Cards Grid */}
            <div className="row g-3 row-deck">
                {employees.length > 0 ? (
                    employees.map((emp) => (
                        <div key={emp.employee_id} className="col-12 col-md-6 col-lg-6 col-xxl-4">
                            <div className="card h-100 border border-dashed rounded-4 overflow-hidden">
                                <div className="card-body p-3">
                                    <div className="d-flex flex-sm-row flex-column align-items-sm-center align-items-start justify-content-between w-100 flex-wrap gap-2">
                                        <div className="d-flex flex-sm-row flex-column align-items-sm-center align-items-start gap-3 flex-grow-1 overflow-hidden">
                                            <div className="flex-shrink-0 position-relative">
                                                {emp.profile_image ? (
                                                    <img
                                                        src={emp.profile_image}
                                                        alt={emp.employee_name}
                                                        className="rounded-circle border border-2 border-white"
                                                        style={{ width: '48px', height: '48px', maxWidth: '48px', maxHeight: '48px', objectFit: 'cover' }}
                                                    />
                                                ) : (
                                                    <div
                                                        className="rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center text-primary border border-2 border-white"
                                                        style={{ width: '48px', height: '48px' }}
                                                    >
                                                        <span className="fw-bold fs-6">
                                                            {emp.employee_name ? emp.employee_name.charAt(0).toUpperCase() : 'E'}
                                                        </span>
                                                    </div>
                                                )}
                                                <div
                                                    className={`position-absolute bottom-0 end-0 rounded-circle border border-2 border-white ${emp.attendance_status?.toLowerCase() === 'present' ? 'bg-success' : 'bg-danger'}`}
                                                    style={{ width: '12px', height: '12px' }}
                                                ></div>
                                            </div>
                                            <div className="flex-grow-1 overflow-hidden">
                                                <h6 className="mb-0 fw-bold text-dark text-truncate">
                                                    {emp.employee_name}
                                                </h6>
                                                <div className="d-flex align-items-center gap-1 text-muted small">
                                                    <span className="text-truncate">#{emp.employee_id || 'ID'}</span>
                                                    <ChevronRight size={12} className="opacity-50" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <span className={`badge rounded-pill px-2 py-1 fw-medium border-0 small ${emp.attendance_status?.toLowerCase() === 'present'
                                                ? 'bg-success bg-opacity-10 text-success'
                                                : 'bg-danger bg-opacity-10 text-danger'
                                                }`}>
                                                {emp.attendance_status}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="col-12">
                        <div className="text-center py-5 w-100 rounded-4 border border-dashed">
                            <div className="mb-4">
                                <div className="d-inline-flex p-4 rounded-circle bg-white shadow-sm text-muted">
                                    <Users size={64} opacity={0.3} />
                                </div>
                            </div>
                            <h5 className="text-dark fw-bold mb-2">
                                {activeRoster ? 'No Assignments Found' : 'Awaiting Selection'}
                            </h5>
                            <p className="text-muted max-width-250 mx-auto px-4">
                                {activeRoster ?
                                    `There are no employees assigned to the ${selectedRosterName} roster for this date.` :
                                    'Select a roster type and date above to view the attendance dashboard data.'}
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AttendanceDashboardList;
